/** DD-LINE-ID-001 Gate 3 — human display id (R2). Stored line_key ≠ display by design. */

import type { Request } from '@/lib/dd-queue/types'

export function formatLineDisplayId(
  requestId: string,
  ordinal: number,
  totalLineCount: number
): string {
  const id = requestId.trim() || 'NOREF'
  if (totalLineCount <= 1) return id
  return `${id}-${String(Math.max(1, ordinal)).padStart(2, '0')}`
}

/** Born single-line (one line total, cancelled included). Ordinal prefers line_ordinal, else 1-based index. */
export function lineDisplayIdForRequest(args: {
  requestId: string
  ordinal?: number | null
  indexZeroBased?: number
  totalLineCount: number
}): string {
  const ordinal =
    args.ordinal != null && args.ordinal > 0
      ? args.ordinal
      : (args.indexZeroBased ?? 0) + 1
  return formatLineDisplayId(args.requestId, ordinal, args.totalLineCount)
}

/** Total lines on the submission (cancelled included) — SPA fallback when server display id is absent. */
export function totalLineCountForRequest(req: Request): number {
  return req.isMaster ? req.children.length : 1
}

